/// <amd-module name="Reporting/Visuals/VisualMessages/ErrorMessage" />
import * as React from "react";
import * as Resources from "Reporting/Visuals/Resources";
import { VssComponent } from "VSS/Platform/Layout";
import { Size, VisualMessageAction, VisualMessageBase } from "./VisualMessageBase";

export interface ErrorProps {
    visualTitle: string;
    size: Size;
    messageBodyText: string;
    action: VisualMessageAction;
    hideTitle?: boolean;
}

/** Used for Rendering non-specific "Error" Experiences. */
export class ErrorMessage extends VssComponent<ErrorProps, {}> {
    public render(): JSX.Element {
        const imageName = this.isAnyDimensionSmall() ? "errorWidget-small" : "errorWidget-large";
        const imageLocation = `ms.vss-reporting/reporting-visuals-common/images/${imageName}.png`;
        return (
            <VisualMessageBase
                visualTitle={this.props.visualTitle}
                messageContent={this.props.messageBodyText}
                size={this.props.size}
                renderSmallImage={this.isAnyDimensionSmall()}
                imagePath={imageLocation}
                altText={Resources.ErrorMessage_AltText}
                action={this.props.action}
                hideTitle={this.props.hideTitle}
            />
        );
    }

    private isAnyDimensionSmall(): boolean {
        return this.props.size.width <= 160 || this.props.size.height <= 160;
    }
}
